var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ui5-date-picker',_vm._g(_vm._b({ref:"datepicker",staticStyle:{"transform":"scaleX(0.98) scaleY(0.98)","margin-top":"-1.5px","margin-right":"11px","margin-left":"-2px"}},'ui5-date-picker',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }